import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'done',
    templateUrl: '../../view/join/done.html'
})
export class DoneComponent {
    @Input() public joinEmail?: string;
    @Output() public nextEvent: EventEmitter<any> = new EventEmitter<any>();

    public next(): void {
        this.nextEvent.emit();
    }
}